import { render } from "./SettingsTabPrecautions.vue?vue&type=template&id=1491af70&scoped=true"
import script from "./SettingsTabPrecautions.vue?vue&type=script&lang=js"
export * from "./SettingsTabPrecautions.vue?vue&type=script&lang=js"

import "./SettingsTabPrecautions.vue?vue&type=style&index=0&id=1491af70&scoped=true&lang=css"

import exportComponent from "C:\\work\\HIMSDeployTest\\HIMSFRONTEND\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1491af70"]])

export default __exports__